import { render, staticRenderFns } from "./ConferenceDetails.vue?vue&type=template&id=09983ba8&scoped=true&"
import script from "./ConferenceDetails.vue?vue&type=script&lang=js&"
export * from "./ConferenceDetails.vue?vue&type=script&lang=js&"
import style0 from "./ConferenceDetails.vue?vue&type=style&index=0&id=09983ba8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09983ba8",
  null
  
)

export default component.exports